import type { LinkingMatrix } from './types';
import { select } from 'redux-saga/effects';
import type { RootState } from 'src/store';
import type { TabState } from 'src/store/reducers/tab';

export function* getTabsThatCanBeCommunicateWith(originatingTabId: string, matrix: LinkingMatrix) {
    const allWidgetsInWorkspace: TabState['byId'] = yield select((state: RootState) => state.tab.byId);
    const allTabsInDashboard = Object.values(allWidgetsInWorkspace);
    const originatingTab = allTabsInDashboard.find((tab) => tab.id === originatingTabId);

    if (!originatingTab?.channelId) return [];

    const originatingChannelId = originatingTab.channelId;
    const otherTabsInChannel = allTabsInDashboard.filter((tab) => {
        if (tab.channelId !== originatingChannelId) return false;
        if (tab.id === originatingTabId) return false;

        // ToDo:
        // So! Here's where we will be able to pull the current tab's rules of who they can publish to
        // it would look something like this:
        // if (originatingTab.channelSubscriptionSettings?.dontPublishTo?.includes(tab.widget.type)) return false;
        // if (tab?.channelSubscriptionSettings?.dontListenTo?.includes(originatingTab.widget.type)) return false;
        // see projects/web/src/store/types/index.ts WidgetTabViewModel.channelSubscriptionSettings

        // The following lines will be replaced in the future with the above lines:
        return matrix[originatingTab.widget.type].includes(tab.widget.type);
    });

    return otherTabsInChannel;
}
